import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOfferForAnalytic } from '../../utils/tracking/types';

export interface IAnalyticState {
  offerForAnalytics: IOfferForAnalytic | null;
  listNumber: number | null;
}

export const initialState: IAnalyticState = {
  offerForAnalytics: null,
  listNumber: null,
};

export const analyticSlice = createSlice({
  initialState,
  name: 'analytic',
  reducers: {
    setOfferForAnalytic: (state, { payload: { offerForAnalytics, listNumber } }: PayloadAction<IAnalyticState>) => {
      state.offerForAnalytics = offerForAnalytics;
      state.listNumber = listNumber;
    },
  },
});

export const { setOfferForAnalytic } = analyticSlice.actions;
